import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { SxProps, Theme } from '@mui/material/styles';

interface Project {
  id: number | string;
  name: string;
}

interface ProjectAutocompleteProps {
  projects: Project[];
  value: string | number | null | (string | number)[];
  onChange: (value: any) => void;
  label?: string;
  placeholder?: string;
  size?: 'small' | 'medium';
  required?: boolean;
  sx?: SxProps<Theme>;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  multiple?: boolean;
}

export const ProjectAutocomplete: React.FC<ProjectAutocompleteProps> = ({
  projects,
  value,
  onChange,
  label = "Проект",
  placeholder = "Найти проект...",
  size = "small",
  required = false,
  sx,
  error,
  helperText,
  disabled = false,
  fullWidth = true,
  multiple = false,
}) => {
  const selectedOption = React.useMemo(() => {
    if (multiple && Array.isArray(value)) {
      return projects.filter(p => value.map(v => String(v)).includes(String(p.id)));
    }
    return projects.find(p => String(p.id) === String(value)) || null;
  }, [projects, value, multiple]);

  return (
    <Autocomplete
      multiple={multiple}
      options={projects}
      getOptionLabel={(option) => option.name || ''}
      value={selectedOption as any}
      onChange={(_, newValue) => {
        if (multiple && Array.isArray(newValue)) {
          onChange(newValue.map(v => String(v.id)));
        } else {
          onChange(newValue ? String((newValue as Project).id) : '');
        }
      }}
      isOptionEqualToValue={(option, val) => String(option.id) === String(val.id)}
      disabled={disabled}
      fullWidth={fullWidth}
      sx={sx}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          size={size}
          required={required}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

